module.exports = __webpack_public_path__ + "static/media/bkg13n.89341ef8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/backgrounds/bkg13n.jpg
// module id = 478
// module chunks = 0